import {
	IUnitDetailsAdditionalRequirementsDto,
	IUnitDetailsAdminDto,
	IUnitDetailsCountryAdminDto,
	IUnitDetailsDto,
	UnitDetailsAdditionalRequirementsDto,
	UnitDetailsAdminDto,
	UnitDetailsCountryAdminDto,
	UnitDetailsDto,
} from 'api/api';
import { SelectItem } from 'primereact/components/selectitem/SelectItem';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { notificationService } from 'services/notification-service';
import {
	getMachineDetails,
	getMachineDetailsWithoutState,
	updateUnitOwnerGroup,
	upsertMachineDetailsAdmin,
	upsertMachineDetailsCountryAdmin,
	upsertMachineDetailsServiceTechnicianOrAdmin,
} from 'state/ducks/machine-details/operations';
import { localized, localizedDynamic, localizedInterpolation } from 'state/i18n';
import { AppState } from 'state/store';
import { ServiceIntervalOptionsInMonths } from 'utilities/constants';
import { getMachineFromIdDataMapOrDefault } from 'utilities/machine-util';
import { hasAtLeastPermissionSuperAdmin, isPremiumFromState } from 'utilities/roles-util';
import { getEmailFromToken } from 'utilities/token-util';
import WhiteCard from 'view/shared/components/cards/white-card';
import { getDateToString } from 'view/shared/components/date-to-string';
import LabelValueCard, {
	LabelValueForCardMap,
	addTranslationLabelValueMapToList,
	getLabelValueOrDefaultToLocalizedNoDataString,
} from 'view/shared/components/label-value-card';
import { LimitedDataLabel } from 'view/shared/components/limited-data-label';
import { ConfirmDialog } from '../../../../shared/components/dialogs/bi-dialog-confirm/dialog-confirm';
import { cardDetailsStyles, cardGeneralClassNames } from '../constants';

const mapStateToProps = (state: AppState, ownProps: AppProps) => {
	const currMachine = getMachineFromIdDataMapOrDefault(
		state.machineDetailsReducer.machineDetails,
		ownProps.machineDetailsId,
		UnitDetailsDto
	);

	const idDataTupleUserGroups = state.groupsReducer.groups.find(g => g.id === getEmailFromToken());
	let userGroups = idDataTupleUserGroups ? idDataTupleUserGroups.data : [];
	const isSuperAdmin = state.userPermissionReducer.UserGroupPermissions.some(ugp =>
		hasAtLeastPermissionSuperAdmin(ugp.roleType)
	);
	const isPremium = isPremiumFromState(state, currMachine.data.ownerGroupId);

	const showLimitedData = currMachine.data.hasSubscription || isSuperAdmin || isPremium;
	return {
		serviceContractTypes: state.machineDetailsReducer.options.serviceContractTypes,
		ownerships: state.machineDetailsReducer.options.ownerShips,
		ownershipId: currMachine.data.ownershipId,
		machineDetailsDto: currMachine.data,
		comment: currMachine.data.comment,
		customerUnitId: currMachine.data.customerUnitId,
		collector: currMachine.data.collector,
		distributor: currMachine.data.distributor,
		distributorCountry: currMachine.data.distributorCountry,
		serviceContractType: currMachine.data.serviceContractTypeId,
		warrantyExpires: currMachine.data.warrantyExpires,
		installationDate: currMachine.data.installationDate,
		lastService: currMachine.data.lastService,
		nextService: currMachine.data.nextService,
		serviceIntervalMonths: currMachine.data.serviceIntervalMonths,
		siteUser: currMachine.data.siteUser,
		siteDescription: currMachine.data.siteDescription,
		city: currMachine.data.siteCity,
		postalCode: currMachine.data.sitePostalCode,
		siteAdress: currMachine.data.siteAddress,
		gpsLocation: currMachine.data.gpsLocation,
		homeLocation: currMachine.data.homeLocation,
		lastTrackerUpdate: currMachine.data.lastTrackerUpdate,
		ownerGroupId: currMachine.data.ownerGroupId,
		userGroups,
		showLimitedData,
		showLimitedSiteData: showLimitedData,
		showLimitedDataForBasicUser: !currMachine.data.limitDataBasicUser || showLimitedData,
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
	updateUnitOwnerGroup: async (unitId: number, ownerGroupId: number) =>
		(await updateUnitOwnerGroup(unitId, ownerGroupId))(dispatch),
	upsertMachineDetailsCountryAdmin: async (machineIds: IUnitDetailsCountryAdminDto) =>
		(await upsertMachineDetailsCountryAdmin(machineIds))(dispatch),
	upsertMachineDetailsAdmin: async (machineIds: IUnitDetailsAdminDto, updateCoordinates: boolean) =>
		(await upsertMachineDetailsAdmin(machineIds, updateCoordinates))(dispatch),
	upsertMachineDetailsServiceTechnicianOrAdmin: async (machineIds: IUnitDetailsAdditionalRequirementsDto) =>
		(await upsertMachineDetailsServiceTechnicianOrAdmin(machineIds))(dispatch),
	getMachineDetails: async (id: string) => (await getMachineDetails(id))(dispatch),
});

interface AppProps {
	machineDetailsId: string;
	isAdmin: boolean;
	isCountryAdmin: boolean;
	isServiceTechnician: boolean;
	id: number;
}

interface SaveLocation {
	dialog: JSX.Element;
	key: keyof UnitDetailsAdminDto;
	value: any;
}

type State = {
	selectedGroupNameId: string | undefined;
	saveLocation?: SaveLocation;
};

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & AppProps;

class MachineOwnerAndLocationCard extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);

		const groupName = this.getGroupNameById();

		this.state = {
			selectedGroupNameId: groupName,
		};
	}

	public render() {
		const machineOwnerPairValues = this.getMachineOwnerPairValues();
		const locationPairValues = this.getLocationPairValues();
		const containerClassName = `${cardGeneralClassNames.classNameContainer} ${cardDetailsStyles.classNameContainer}`;

		return (
			<WhiteCard title={localized('MachineOwnerDetails')} classNameContainer={containerClassName}>
				<LabelValueCard
					labels={machineOwnerPairValues.labels}
					values={machineOwnerPairValues.valuesForLabels}
				/>

				<h3 className="text-bold margin-top-40">{localized('location')}</h3>
				<LabelValueCard labels={locationPairValues.labels} values={locationPairValues.valuesForLabels} />
				{this.state.saveLocation?.dialog}
			</WhiteCard>
		);
	}
	/*				<NavLink
					className={`${cardMapNoPadding} border-shadow-dark-all-corners border-radius-5`}
					to={{ pathname: Routes.Location, search: this.props.id }}
					onClick={this.setAsSelectedMachine}
				>
					{machineLocationData}
				</NavLink> */
	private getMachineOwnerPairValues(): LabelValueForCardMap {
		const retMap: LabelValueForCardMap = {
			labels: [],
			valuesForLabels: [],
		};
		const editable = false;
		const serviceContractTypeOptions: any[] = [];
		this.props.serviceContractTypes &&
			this.props.serviceContractTypes.forEach(element => {
				serviceContractTypeOptions.push({
					label: element.nameTranslationKey ? localizedDynamic(element.nameTranslationKey) : '',
					value: element.id,
				});
			});

		let serviceContractTypeSelected = serviceContractTypeOptions.find(
			a => a.value === this.props.serviceContractType
		);
		if (!serviceContractTypeSelected) {
			serviceContractTypeSelected = { label: ' ', value: ' ' };
		}

		const serviceIntervalOptions: SelectItem[] = [
			{ label: ' ', value: null },
			...ServiceIntervalOptionsInMonths.map(months => ({
				label: localizedInterpolation('monthsCount', { months }),
				value: months,
			})),
		];

		// Next Service is derived only once both a Last Service and an interval are stored; until then it stays hand-entered.
		const derivesNextService = !!this.props.serviceIntervalMonths && !!this.props.lastService;

		const userGroupsOptions: SelectItem[] = [];
		const allGroupNames = this.props.userGroups.map(g => g.groupName);
		const duplicateGroupNames = allGroupNames.filter((item, index) => allGroupNames.indexOf(item) !== index);
		this.props.userGroups &&
			this.props.userGroups.forEach(g => {
				let label = g.groupName;
				if (duplicateGroupNames.includes(g.groupName)) {
					const parentGroup = this.props.userGroups.find(ug => ug.id === g.parentGroupId);
					label = parentGroup ? `${parentGroup.groupName}: ${g.groupName}` : g.groupName;
				}

				userGroupsOptions.push({
					label,
					value: g.id,
				});
			});

		let userGroupSelected = userGroupsOptions.find(ug => ug.value === this.props.ownerGroupId);
		if (!userGroupSelected) {
			userGroupSelected = { label: ' ', value: ' ' };
		}

		const ownerShipOptions: SelectItem[] = [];
		this.props.ownerships &&
			this.props.ownerships.forEach(element => {
				ownerShipOptions.push({
					label: element.nameTranslationKey ? localizedDynamic(element.nameTranslationKey) : '',
					value: element.id,
				});
			});

		let ownerShipSelected = ownerShipOptions.find(a => a.value === this.props.ownershipId);
		if (!ownerShipSelected) {
			ownerShipSelected = { label: ' ', value: ' ' };
		}

		addTranslationLabelValueMapToList(
			'distributor',
			<LimitedDataLabel
				valueForLabel={getLabelValueOrDefaultToLocalizedNoDataString(this.props.distributor)}
				showLimitedData={this.props.showLimitedDataForBasicUser}
			/>,

			retMap,
			editable
		);
		addTranslationLabelValueMapToList(
			'distributorCountry',
			<LimitedDataLabel
				valueForLabel={getLabelValueOrDefaultToLocalizedNoDataString(this.props.distributorCountry)}
				showLimitedData={this.props.showLimitedDataForBasicUser}
			/>,
			retMap,
			editable
		);

		addTranslationLabelValueMapToList(
			'groupName',
			getLabelValueOrDefaultToLocalizedNoDataString(this.getGroupNameById()),
			retMap,
			this.props.isAdmin,
			this.setGroupName,
			'dropdown',
			userGroupSelected.value,
			userGroupsOptions
		);

		addTranslationLabelValueMapToList(
			'siteUser',
			<LimitedDataLabel
				valueForLabel={getLabelValueOrDefaultToLocalizedNoDataString(this.props.siteUser)}
				showLimitedData={this.props.showLimitedSiteData}
			/>,
			retMap,
			this.props.showLimitedData && this.props.isAdmin,
			(value: any) => this.saveItemAdmin('siteUser', value)
		);
		addTranslationLabelValueMapToList(
			'siteDescription',
			<LimitedDataLabel
				valueForLabel={getLabelValueOrDefaultToLocalizedNoDataString(this.props.siteDescription)}
				showLimitedData={this.props.showLimitedSiteData}
			/>,
			retMap,
			this.props.showLimitedData && this.props.isAdmin,
			(value: any) => this.saveItemAdmin('siteDescription', value)
		);
		addTranslationLabelValueMapToList(
			'ownership',
			getLabelValueOrDefaultToLocalizedNoDataString(ownerShipSelected.label),
			retMap,
			this.props.showLimitedData && this.props.isAdmin,
			(value: any) => this.saveItemAdmin('ownershipId', value),
			'dropdown',
			ownerShipSelected.value,
			ownerShipOptions // What can be picked?
		);
		addTranslationLabelValueMapToList(
			'customerUnitId',
			<LimitedDataLabel
				valueForLabel={getLabelValueOrDefaultToLocalizedNoDataString(this.props.customerUnitId)}
				showLimitedData={this.props.showLimitedData}
			/>,
			retMap,
			this.props.showLimitedData && this.props.isAdmin,
			(value: any) => this.saveItemAdmin('customerUnitId', value)
		);
		addTranslationLabelValueMapToList(
			'collector',
			<LimitedDataLabel
				valueForLabel={getLabelValueOrDefaultToLocalizedNoDataString(this.props.collector)}
				showLimitedData={this.props.showLimitedData}
			/>,
			retMap,
			this.props.showLimitedData && this.props.isAdmin,
			(value: any) => this.saveItemAdmin('collector', value)
		);
		addTranslationLabelValueMapToList(
			'installationDate',
			<LimitedDataLabel
				valueForLabel={this.props.installationDate ? getDateToString(this.props.installationDate) : ''}
				showLimitedData={this.props.showLimitedData}
			/>,
			retMap,
			this.props.showLimitedData && this.props.isCountryAdmin,
			(value: any) => this.saveItemCountryAdmin('installationDate', value),
			'datePicker',
			this.props.installationDate
		);
		addTranslationLabelValueMapToList(
			'warrantyExpires',
			<LimitedDataLabel
				valueForLabel={this.props.warrantyExpires ? getDateToString(this.props.warrantyExpires) : ''}
				showLimitedData={this.props.showLimitedData}
			/>,
			retMap,
			this.props.showLimitedData && this.props.isCountryAdmin,
			(value: any) => this.saveItemCountryAdmin('warrantyExpires', value),
			'datePicker',
			this.props.warrantyExpires
		);
		addTranslationLabelValueMapToList(
			'serviceContractType',
			<LimitedDataLabel
				valueForLabel={getLabelValueOrDefaultToLocalizedNoDataString(serviceContractTypeSelected.label)}
				showLimitedData={this.props.showLimitedData}
			/>,
			retMap,
			this.props.showLimitedData && this.props.isCountryAdmin,
			(value: any) => this.saveItemCountryAdmin('serviceContractTypeId', value),
			'dropdown',
			serviceContractTypeSelected.value,
			serviceContractTypeOptions // What can be picked?
		);
		addTranslationLabelValueMapToList(
			'lastService',
			<LimitedDataLabel
				valueForLabel={this.props.lastService ? getDateToString(this.props.lastService) : ''}
				showLimitedData={this.props.showLimitedData}
			/>,
			retMap,
			this.props.showLimitedData && (this.props.isAdmin || this.props.isServiceTechnician),
			(value: any) => this.saveItemServiceTechnicianOrAdmin('lastService', value),
			'datePicker',
			this.props.lastService
		);
		addTranslationLabelValueMapToList(
			'serviceInterval',
			<LimitedDataLabel
				valueForLabel={
					this.props.serviceIntervalMonths
						? localizedInterpolation('monthsCount', { months: this.props.serviceIntervalMonths })
						: ''
				}
				showLimitedData={this.props.showLimitedData}
			/>,
			retMap,
			this.props.showLimitedData && (this.props.isAdmin || this.props.isServiceTechnician),
			(value: any) => this.saveItemServiceTechnicianOrAdmin('serviceIntervalMonths', value),
			'dropdown',
			this.props.serviceIntervalMonths,
			serviceIntervalOptions
		);
		addTranslationLabelValueMapToList(
			'nextService',
			<LimitedDataLabel
				valueForLabel={this.props.nextService ? getDateToString(this.props.nextService) : ''}
				showLimitedData={this.props.showLimitedData}
			/>,
			retMap,
			this.props.showLimitedData &&
				(this.props.isAdmin || this.props.isServiceTechnician) &&
				!derivesNextService,
			(value: any) => this.saveItemServiceTechnicianOrAdmin('nextService', value),
			'datePicker',
			this.props.nextService
		);
		addTranslationLabelValueMapToList(
			'comments',
			<LimitedDataLabel
				valueForLabel={getLabelValueOrDefaultToLocalizedNoDataString(this.props.comment)}
				showLimitedData={this.props.showLimitedData}
			/>,
			retMap,
			this.props.showLimitedData && this.props.isAdmin,
			(value: any) => this.saveItemAdmin('comment', value),
			'textArea'
		);
		return retMap;
	}

	private getGroupNameById = () => {
		const machineGroup = this.props.userGroups && this.props.userGroups.find(g => g.id === this.props.ownerGroupId);
		const groupName = machineGroup ? machineGroup.groupName : '';

		return groupName;
	};

	private async saveItemCountryAdmin(key: keyof UnitDetailsCountryAdminDto, value: any) {
		let machineDetailsDto = { ...this.props.machineDetailsDto } as IUnitDetailsCountryAdminDto;

		machineDetailsDto[key] = value;

		await this.props.upsertMachineDetailsCountryAdmin(machineDetailsDto);
	}

	private async saveItemAdmin(key: keyof UnitDetailsAdminDto, value: any, updateCoordinates = false) {
		let machineDetailsDto = { ...this.props.machineDetailsDto } as IUnitDetailsAdminDto;
		if (key === 'homeLocation') {
			let latlongArray = value.split(',');
			machineDetailsDto['homeLatitude'] = latlongArray[0];
			machineDetailsDto['homeLongitude'] = latlongArray[1];
			machineDetailsDto[key] = value;
		} else {
			machineDetailsDto[key] = value;
		}

		await this.props.upsertMachineDetailsAdmin(machineDetailsDto, updateCoordinates);
	}

	private async saveItemServiceTechnicianOrAdmin(key: keyof UnitDetailsAdditionalRequirementsDto, value: any) {
		// The machine sync can move Last Service while this page is open; saving the cached unit would write it back.
		const currentMachineDetails = await getMachineDetailsWithoutState(this.props.machineDetailsId);
		if (!currentMachineDetails) {
			return;
		}

		let machineDetailsDto = { ...currentMachineDetails } as IUnitDetailsAdditionalRequirementsDto;

		machineDetailsDto[key] = value;

		await this.props.upsertMachineDetailsServiceTechnicianOrAdmin(machineDetailsDto);
	}

	private async clearGpsLocation() {
		let machineDetailsDto = { ...this.props.machineDetailsDto } as IUnitDetailsDto;
		machineDetailsDto['homeLatitude'] = undefined;
		machineDetailsDto['homeLongitude'] = undefined;
		machineDetailsDto.homeLocation = null!;

		await this.props.upsertMachineDetailsAdmin(machineDetailsDto, true);
	}

	private saveLocationWithCoordinates = () => {
		this.saveItemAdmin(this.state.saveLocation!.key, this.state.saveLocation!.value, true);
		this.setState({ saveLocation: undefined });
	};

	private saveLocationWithoutCoordinates = () => {
		this.saveItemAdmin(this.state.saveLocation!.key, this.state.saveLocation!.value);
		this.setState({ saveLocation: undefined });
	};

	private saveItemWithDialogOnLocation = (key: keyof UnitDetailsAdminDto, value: any) => {
		let dialog: JSX.Element = (
			<ConfirmDialog
				header={localized('ChangeLocation')}
				visible={true}
				confirmColor="org-primary"
				dialogMessage={localized('LocationChangeConfirmMessage')}
				confirmMessage={localized('ChangeLocation')}
				cancelMessage={localized('No')}
				onConfirm={this.saveLocationWithCoordinates}
				onCancel={this.saveLocationWithoutCoordinates}
				onHide={this.saveLocationWithoutCoordinates}
			/>
		);

		this.setState({ saveLocation: { dialog: dialog, key: key, value: value } });
	};

	private getLocationPairValues(): LabelValueForCardMap {
		const retMap: LabelValueForCardMap = {
			labels: [],
			valuesForLabels: [],
		};

		addTranslationLabelValueMapToList(
			'siteCity',
			<LimitedDataLabel
				valueForLabel={getLabelValueOrDefaultToLocalizedNoDataString(this.props.city)}
				showLimitedData={this.props.showLimitedSiteData}
			/>,
			retMap,
			this.props.showLimitedData && this.props.isAdmin,
			(value: any) => this.saveItemWithDialogOnLocation('siteCity', value)
		);
		addTranslationLabelValueMapToList(
			'sitePostalCode',
			<LimitedDataLabel
				valueForLabel={getLabelValueOrDefaultToLocalizedNoDataString(this.props.postalCode)}
				showLimitedData={this.props.showLimitedSiteData}
			/>,
			retMap,
			this.props.showLimitedData && this.props.isAdmin,
			(value: any) => this.saveItemWithDialogOnLocation('sitePostalCode', value)
		);
		addTranslationLabelValueMapToList(
			'siteAddress',
			<LimitedDataLabel
				valueForLabel={getLabelValueOrDefaultToLocalizedNoDataString(this.props.siteAdress)}
				showLimitedData={this.props.showLimitedSiteData}
			/>,
			retMap,
			this.props.showLimitedData && this.props.isAdmin,
			(value: any) => this.saveItemWithDialogOnLocation('siteAddress', value)
		);
		addTranslationLabelValueMapToList(
			'gpsLocation',
			<LimitedDataLabel
				valueForLabel={getLabelValueOrDefaultToLocalizedNoDataString(this.props.gpsLocation)}
				showLimitedData={this.props.showLimitedData}
			/>,
			retMap
		);
		addTranslationLabelValueMapToList(
			'homeLocation',
			<LimitedDataLabel
				valueForLabel={getLabelValueOrDefaultToLocalizedNoDataString(this.props.homeLocation)}
				showLimitedData={this.props.showLimitedSiteData}
			/>,
			retMap,
			this.props.showLimitedData && this.props.isAdmin,
			this.saveHomeLocation
		);
		return retMap;
	}

	private setGroupName = async (e: any) => {
		if (e && e !== this.state.selectedGroupNameId) {
			let machineDetailsDto = { ...this.props.machineDetailsDto } as IUnitDetailsDto;
			machineDetailsDto['ownerGroupId'] = e;

			const unitId = Number(machineDetailsDto.unitId);
			if (!isNaN(unitId) && machineDetailsDto.ownerGroupId) {
				await this.props.updateUnitOwnerGroup(unitId, machineDetailsDto.ownerGroupId!);
			}

			//We need to call this to get the new distributor
			this.props.getMachineDetails(this.props.machineDetailsId);
		}

		this.setState({ selectedGroupNameId: e || this.props.ownerGroupId });
	};

	private saveHomeLocation = (value: string) => {
		let latlongArray = value.split(',');
		if (
			latlongArray.length === 2 &&
			Number(latlongArray[0]).toString() !== 'NaN' &&
			Number(latlongArray[1]).toString() !== 'NaN'
		) {
			this.saveItemAdmin('homeLocation', value);
		} else if (latlongArray.length === 1 && latlongArray[0] === '') {
			this.clearGpsLocation();
		} else {
			notificationService.showWarningMessage(localized('Error_HomeLocationNeedsToBeOfFormat'));
		}
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(MachineOwnerAndLocationCard);
